export enum IncentivationDataType {
    Binary = "Binary",
    Score = "Score",
    ManualInput = "ManualInput",
    None = "None"
};
